exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-left-layout>*{float:left;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/flow/LeftLayout.less
// module id = 177
// module chunks = 0